export default {
    forceNew: true,
    timeout: 5000,
    reconnection: false,
    transports: ["websocket"],
};
